export enum DiscountCouponState {
    USED = "USED",
    UNUSED = "UNUSED"
}
